import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { storage } from "../../../Services/storage.service";
import { storageKeys } from "../../../Constants/storage.key";
import { Modal } from "react-bootstrap";
import { FaSignInAlt } from "react-icons/fa";
import { ImSpinner9 } from "react-icons/im";
import { Alert } from "react-bootstrap";
import { usersService } from "../../../Services/users.service";
import { ToastComponent } from "../../Components/ToastComponent";

export default function UserNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [userSession] = useState(storage.get(storageKeys.settings));
  const [userSessionData] = useState(storage.get(storageKeys.user_data));
  const [showPassModal, setShowPassModal] = useState(false);
  const [loadingPass, setLoadingPass] = useState(false);
  const [alertShow, setAlertShow] = useState({ show: false, message: "" });
  const [pass, setPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [toastParams, setToastParams] = useState("");

  function closeUserMenu() {
    document.getElementById("user-nav-menu")?.setAttribute("expanded", false);
    document.getElementById("user-nav-menu")?.classList.remove("show");
  }

  function closeLanguageMenu() {
    document
      .getElementById("language-nav-menu")
      ?.setAttribute("expanded", false);
    document.getElementById("language-nav-menu")?.classList.remove("show");
  }

  document.body.addEventListener("click", closeUserMenu, true);
  document.body.addEventListener("click", closeLanguageMenu, true);

  const openPassModal = () => {
    setShowPassModal(true);
  };

  const closePassModal = () => {
    setShowPassModal(false);
    setPass("");
    setConfirmPass("");
  };

  const resetPass = async () => {
    try {
      if (!validatePass()) return;
      setLoadingPass(true);
      const obj = {
        userId: userSession.userId,
        userLogId: userSession.userLogId,
        pass: pass,
      };
      const response = await usersService.passwordChange(obj);
      if (response) {
        closePassModal();
        setToastParams(
          JSON.stringify({
            show: true,
            title: t("USER_NAV.PASSWORD_CHANGED"),
            body: t("USER_NAV.PASSWORD_CHANGED_SUCCESS"),
            color: "success",
          }),
        );
      } else {
        setAlertShow({
          show: true,
          message: t("USER_NAV.PASSWORD_CHANGE_ERROR"),
        });
      }
    } catch (err) {
      setAlertShow({
        show: true,
        message: t("USER_NAV.PASSWORD_CHANGE_ERROR"),
      });
    } finally {
      setLoadingPass(false);
    }
  };

  const validatePass = () => {
    if (!confirmPass || !pass) {
      setAlertShow({
        show: true,
        message: t("USER_NAV.FILL_BOTH_FIELDS"),
      });
      return false;
    }

    if (confirmPass !== pass) {
      setAlertShow({
        show: true,
        message: t("USER_NAV.PASSWORDS_MUST_MATCH"),
      });
      return false;
    }

    return true;
  };

  return (
    <>
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />
      <ul className="navbar-nav flex-row align-items-center ms-auto user-nav-container">
        {/* <!-- User --> */}
        <li className="nav-item navbar-dropdown dropdown-user dropdown">
          <ul
            className="dropdown-menu dropdown-menu-end show user-nav-container"
            id="user-nav-menu"
            expanded="true"
          >
            <li>
              <a
                style={{ display: "flex", alignItems: "center", gap: 4 }}
                className="dropdown-item"
                href="/#/profile"
              >
                <i className="bx bx-user me-2"></i>
                <span
                  className="align-middle"
                  style={{ color: "var(--text-primary)", cursor: "pointer" }}
                >
                  {t("USER_NAV.USER_PROFILE")}
                </span>
              </a>
            </li>
            <li>
              <div
                className="dropdown-item"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
                onClick={openPassModal}
              >
                <i className="bx bx-cog me-2"></i>
                <span
                  className="align-middle"
                  style={{ color: "var(--text-primary)", cursor: "pointer" }}
                >
                  {t("USER_NAV.CHANGE_PASSWORD")}
                </span>
              </div>
            </li>
            {[10, 12, 13].includes(userSession.levelId) && (
              <li>
                <div
                  className="dropdown-item"
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                  onClick={() => navigate(`/notifications-config`)}
                >
                  <i className="bx bx-bell me-2"></i>
                  <span
                    className="align-middle"
                    style={{ color: "var(--text-primary)", cursor: "pointer" }}
                  >
                    {t("USER_NAV.NOTIFICATIONS")}
                  </span>
                </div>
              </li>
            )}
            {userSessionData.isMasterClient === "S" && (
              <>
                {(userSession.levelId === 13 || userSession.levelId === 1 || userSession.levelId === 2) && (
                  <li>
                    <div
                      className="dropdown-item"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                      onClick={() => navigate(`/client-users`)}
                    >
                      <i className="bx bx-user me-2"></i>
                      <span
                        className="align-middle"
                        style={{
                          color: "var(--text-primary)",
                          cursor: "pointer",
                        }}
                      >
                        {t("USER_NAV.CLIENT_USERS")}
                      </span>
                    </div>
                  </li>
                )}
                <li>
                  <div
                    className="dropdown-item"
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                    }}
                    onClick={() =>
                      navigate(`/clients/details/${userSessionData?.clientId}`)
                    }
                  >
                    <i className="bx bx-cog me-2"></i>
                    <span
                      className="align-middle"
                      style={{
                        color: "var(--text-primary)",
                        cursor: "pointer",
                      }}
                    >
                      {t("USER_NAV.COMPANY")}
                    </span>
                  </div>
                </li>
                
              </>
            )}
          </ul>
        </li>
        <li>
          <ul
            className="dropdown-menu dropdown-menu-end"
            id="user-nav-menu"
            expanded="false"
          ></ul>
        </li>
      </ul>

      {/* MODAL ALTERAR SENHA */}
      <Modal show={showPassModal} onHide={closePassModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t("USER_NAV.CHANGE_PASSWORD")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert
            variant="danger"
            style={alertShow.show ? { display: "block" } : { display: "none" }}
          >
            <strong>{t("COMMON.ATTENTION")}</strong>
            <p>{alertShow.message}</p>
          </Alert>
          <div className="wrap-input100 validate-input">
            <input
              className="input100 input-pass"
              type="password"
              name="pass"
              value={pass}
              disabled={loadingPass}
              onChange={(e) => {
                setAlertShow({ show: false, message: "" });
                setPass(e.target.value);
              }}
              autoComplete="off"
            />
            <span className="label-input100">{t("LOGIN.NEW_PASSWORD")}</span>
          </div>

          <div className="wrap-input100 validate-input">
            <input
              className="input100"
              type="password"
              name="confirmPass"
              value={confirmPass}
              disabled={loadingPass}
              onChange={(e) => {
                setAlertShow({ show: false, message: "" });
                setConfirmPass(e.target.value);
              }}
            />
            <span className="label-input100">
              {t("LOGIN.CONFIRM_PASSWORD")}
            </span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="login100-form-btn"
            type="button"
            onClick={resetPass}
            disabled={loadingPass}
          >
            <>
              {loadingPass && (
                <ImSpinner9
                  className="icon-spin"
                  style={{ marginRight: "10px" }}
                />
              )}
              {!loadingPass && <FaSignInAlt style={{ marginRight: "10px" }} />}
            </>
            <span>{loadingPass ? t("LOGIN.RESETTING") : t("LOGIN.RESET")}</span>
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
